export interface LayoutField { id: string; tipo: string; nome?: string; }
export type ChecklistLayoutRow<T extends LayoutField> = T & { cells?: T[]; fullWidth?: boolean };

export const isChecklistWideField = (field: LayoutField): boolean => {
  if (field.tipo.startsWith('dropdown') || ['assinatura', 'signature', 'marcação', 'marcacao', 'mark', 'timestamp with time zone', 'mensagem pronta'].includes(field.tipo)) return true;
  const name = (field.nome ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  return (field.tipo === 'text' || /^cep[2-6]$/.test(field.tipo)) && /\b(enderecos?|local|locais|observacao|observacoes)\b/.test(name);
};

/** Preserva a ordem; campos isolados e os tipos largos ocupam a linha inteira. */
export const groupChecklistRows = <T extends LayoutField>(fields: T[], columns: number): ChecklistLayoutRow<T>[] => {
  const rows: ChecklistLayoutRow<T>[] = [];
  const columnCount = Math.max(1, Math.min(2, columns));
  let cells: T[] = [];
  const flush = () => {
    if (cells.length) rows.push({ ...cells[0], cells, fullWidth: cells.length === 1 });
    cells = [];
  };
  fields.forEach(field => {
    if (isChecklistWideField(field)) {
      flush(); rows.push({ ...field, cells: [field], fullWidth: true });
    } else {
      cells.push(field);
      if (cells.length === columnCount) flush();
    }
  });
  flush();
  return rows;
};

export const countChecklistFilledFields = (fields: LayoutField[], values: Record<string, string | undefined>): number =>
  fields.filter(field => values[field.id] !== undefined && values[field.id] !== null && values[field.id] !== '').length;

/** O retorno aparece quando o início do grupo aberto já ultrapassou a margem visível. */
export const getChecklistReturnGroup = (
  groups: { title: string; expanded: boolean; top: number; height: number; headerHeight: number }[],
  scrollY: number
): string | null => groups.find(group => group.expanded && Number.isFinite(group.top) &&
  Number.isFinite(group.headerHeight) && group.headerHeight >= 0 &&
  scrollY > group.top + Math.min(group.headerHeight, 12) && scrollY < group.top + group.height)?.title ?? null;
